import request from "@/utils/request"

const learningHabitsPost = () => request.get("/api/business/posts/learning-habits").then((response) => response)

export default {
  learningHabitsPost
}
